import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { Component, OnInit } from "@angular/core";
import { locale as italian } from "../../../../../i18n/it";
import { UtilsService } from "../../../../../auth/service/utils.service";
import { environment } from "../../../../../../environments/environment";
import { AuthenticationService } from "../../../../../auth/service";
import { CitiesService } from "../../../../../auth/service/cities.service";
import { ICity } from "app/auth/models/cities";
import { ICustomerAddressList } from "../../../customer.interface";
import { CustomerService } from "../../../customer.service";

@Component({
  selector: "app-site",
  templateUrl: "./customers-sites-list.component.html",
  styleUrls: ["./customers-sites-list.component.scss"],
})
export class CustomersSitesListComponent implements OnInit {
  public contentHeader: IContentHeader = null;
  private site: ICustomerAddressList[] = [];
  public filteredAddresses: ICustomerAddressList[] = [];
  public searchKey: string = "";
  public tableLimit: number = 10;
  public otherCity: ICity = null;

  constructor(
    public _utilService: UtilsService,
    public customerService: CustomerService,
    public _authenticationService: AuthenticationService,
    private _citiesService: CitiesService,
  ) {}
  /*In caso di sede estera città zipcode e provincia saranno impostati a null*/
  async ngOnInit() {
    await this._citiesService.getList();
    this.otherCity = this._citiesService.list.find((city: ICity) => city.name === "Altro");
    this.site = await this.customerService.getAddresses().then((addresses: ICustomerAddressList[]) => {
      return addresses.map((address: ICustomerAddressList) => {
        if (address.client && address.client.logo) {
          address.client.logo = environment.CDN_URL + "/" + address.client.logo;
        }
        return address;
      });
    });

    await this.search();

    this.contentHeader = {
      headerTitle: italian.data.MENU.CUSTOMERS_LOCATION,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: italian.data.CUSTOMERS,
            isLink: false,
          },
          {
            name: italian.data.MENU.CUSTOMERS_LOCATION,
            isLink: false,
          },
        ],
      },
    };
  }

  async delete(address: ICustomerAddressList) {
    let deleteText: string = await this._utilService.translate("ALERT.CONFIRM_DELETE_TEXT");

    await this._utilService
      .showSWALDeleteConfirmation({ text: deleteText })
      .then(async (result) => {
        if (result.value) {
          this._utilService.showLoading();
          await this.customerService
            .deleteAddress(address.id)
            .then(async () => {
              this.site = this.site.filter((item) => item.id != address.id);
              this.filteredAddresses = this.filteredAddresses.filter((item) => item.id != address.id);
              this._utilService.hideLoading();
              await this._utilService.showSWALSuccess({ text: "SUCCESS_DELETE_CUSTOMER_SITE" });
            })
            .catch(async () => {
              this._utilService.hideLoading();
              await this._utilService.showSWALError({ text: "ERROR_DELETE_CUSTOMER_SITE" });
            });
        } else if (result.isDismissed) {
          this._utilService.hideLoading();
          await this._utilService.showSWALError({
            title: "ABORTED_TITLE",
            text: "ABORTED_TEXT",
          });
        }
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_DELETE_CUSTOMER_SITE" });
      });
  }

  async search() {
    const key: string = this.searchKey.trim().toLowerCase();
    let filteredAddresses: ICustomerAddressList[] = this.site;
    if (key.length > 0) {
      filteredAddresses = filteredAddresses.filter((item: ICustomerAddressList) => {
        return (
          (item.client && item.client.name && item?.client?.name?.toLowerCase().includes(key)) ||
          (item.client && item.client.business_name && item?.client?.business_name?.toLowerCase().includes(key)) ||
          (item.street && item?.street?.toLowerCase().includes(key)) ||
          (item.city && item?.city?.toLowerCase().includes(key)) ||
          (item.label && item?.label?.toLowerCase().includes(key))
        );
      });
    }
    this.filteredAddresses = filteredAddresses;
  }
}
